import React from "react";
import styled from "styled-components";

import { Fonts } from "assets/fonts";

const StyledPill = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  border-radius: 25px;
  ${Fonts.semiBold_14}
  cursor: default;
  color: ${(p) => p.theme.textMediumContrast};
`;

export interface PillProps {
  children: React.ReactNode;
  className?: string;
  title: string;
}
export const Pill = (props: PillProps) => {
  const { className, title, children } = props;
  return (
    <StyledPill title={title} className={className}>
      {children}
    </StyledPill>
  );
};
